import { anyToDate } from 'vtils/date'
import {
  CountdownDiff,
  CountdownInfo,
  CountdownStatus,
  getCountdownInfo,
} from './get_countdown_info'

export type SeckillStatus = CountdownStatus
export type SeckillDiff = CountdownDiff
export interface SeckillInfo extends CountdownInfo {
  /** 是否显示计时器 */
  showTimer: boolean
  /** 是否全天时段 */
  isFull: boolean
}

export function getSeckillInfo(
  session: Record<string, string | number>,
  onChange?: (info: SeckillInfo) => any,
) {
  return getCountdownInfo<SeckillInfo>({
    startDate: anyToDate(`${session.startDate} ${session.startTime}`),
    endDate: anyToDate(`${session.startDate} ${session.endTime}`),
    transformInfo: ii => ({
      ...ii,
      isFull: session.timeType === 1,
      showTimer: ii.isRunning || (ii.isToday && ii.isPending),
    }),
    onChange: onChange,
  })
}
